// extracted by mini-css-extract-plugin
module.exports =  {"trigger":"addon_info_tooltip-module_trigger_b34b2","popover":"addon_info_tooltip-module_popover_fc506"};